// extracted by mini-css-extract-plugin
module.exports = {"main":"ingredient-tabs_main__34-bT"};